import {NgModule} from '@angular/core';
import {InventoryTableComponent} from './inventory-table.component';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  declarations: [
    InventoryTableComponent,
  ],
  exports: [
    InventoryTableComponent,
  ]
})
export class InventoryTableModule {
}
